if (window.location.pathname === '/') {
// Hero image
let heroImage = document.querySelector('.aomai-hero-image');
let heroContainer = document.querySelector('.aomai-hero-container');
let displayWidth = window.innerWidth;

// Marquee
let aomaiMarquee = document.querySelector('.aomaimarqueesdiv');


function verificarPosicaoUsuario() {
        const paiHeight = heroContainer.getBoundingClientRect();

        const posicaoDesejada = paiHeight.height + (window.innerHeight * 0.1);
        const posicaoDesejadaIOS = paiHeight.height + (paiHeight.height * 0.085);
        const posicaoDesejadaMobile = paiHeight.height + (window.innerHeight * 0.009);

        const posicaoAtualScroll = window.scrollY + window.innerHeight;

        // IOS
        if (displayWidth <= 1000) {
            if (posicaoAtualScroll >= posicaoDesejadaIOS) {
                heroImage.classList.add('aomai-ios-fix-image');

                aomaiMarquee.classList.add('aomai-marquee-fix');
            } else {
                heroImage.classList.remove('aomai-ios-fix-image');

                aomaiMarquee.classList.remove('aomai-marquee-fix');
            }
        }

        // MOBILE
        if (displayWidth <= 1000) {
            if (posicaoAtualScroll >= posicaoDesejadaMobile) {
                heroImage.classList.add('aomai-fix-image');

                aomaiMarquee.classList.add('aomai-marquee-fix');
            } else {
                heroImage.classList.remove('aomai-fix-image');

                aomaiMarquee.classList.remove('aomai-marquee-fix');
            }

        // DESKTOP
        }else{
            if (posicaoAtualScroll >= posicaoDesejada) {
                aomaiMarquee.classList.add('aomai-marquee-fix');

                heroImage.style.position = 'absolute';
                heroImage.style.width = '100vw';
                heroImage.style.top = 'calc(100% + 90vh)';

            } else {
                aomaiMarquee.classList.remove('aomai-marquee-fix');

                heroImage.style.position = 'fixed';
                heroImage.style.width = '100vw';
                heroImage.style.top = '0';

            }
        }

       
    }

window.addEventListener('scroll', function() {
    let scrollPosition = window.scrollY;
    let viewportHeight = window.innerHeight;
    let newSize;
    
    if (displayWidth <= 1000) {
         newSize = 190 - (scrollPosition * (viewportHeight / 10 ) / viewportHeight );
        
        if (newSize <= 75) {
            newSize = 75;
        }
    }else{
         newSize = 100 - (scrollPosition * (viewportHeight / 25 ) / viewportHeight );
        
        if (newSize <= 30) {
            newSize = 30;
        } 
    }

    heroImage.style.backgroundSize = newSize + 'vw';
    verificarPosicaoUsuario();
});

verificarPosicaoUsuario();
}



